import { render } from "./ResourceTable.vue?vue&type=template&id=23268a4e&scoped=true"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"

import "./ResourceTable.vue?vue&type=style&index=0&id=23268a4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23268a4e"]])

export default __exports__